import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "user-info"
}
const _hoisted_2 = { style: {"margin-top":"20px"} }
const _hoisted_3 = {
  key: 0,
  class: "area-ship-container"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { style: {"width":"200px"} }
const _hoisted_6 = { style: {"width":"200px"} }
const _hoisted_7 = { style: {"width":"200px"} }
const _hoisted_8 = {
  key: 1,
  class: "empty-ship-list"
}
const _hoisted_9 = {
  key: 1,
  class: "area-ship-container",
  style: {"height":"60px"}
}

import {
  createAreaApi,
  getAreaNameListApi,
  getShipWithTypeListByAreaId,
} from "@/api/productApi";
import { fetchUserByIdApi } from "@/api/user/userApi";
import router from "@/router";
import { Area, ShipAuthorization, ShipVO } from "@/types/product";
import { User } from "@/types/user";
import { orderBy } from "lodash-es";
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { getName } from "@/util/i18nUtil";
import { getStatusColor } from "@/util/colorUtil";
import { useI18n } from "vue-i18n";
import { ElMessage } from "element-plus";
import _ from "lodash";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserInfoView',
  setup(__props) {

const route = useRoute();
const userId = computed(() => route.query.userId as string);
const user = ref<User>();
const { t } = useI18n();

// 获取用户基本信息
const fetchUserById = async () => {
  if (userId.value) {
    const response = await fetchUserByIdApi(userId.value);
    if (response) {
      user.value = response;
    } else {
      sessionStorage.setItem(
        "previousRoute",
        (router.options.history.state.back as string) || "/"
      );
      router.push({ name: "contentError" });
    }
  } else {
    console.log(router.options.history.state.back as string);
    sessionStorage.setItem(
      "previousRoute",
      (router.options.history.state.back as string) || "/"
    );
    router.push({ name: "contentError" });
  }
};

// 获取区域列表
const areaNameList = ref<Area[]>([]);
const fetchAreaList = async () => {
  const response = await getAreaNameListApi(userId.value);
  if (response) {
    areaNameList.value = response;
    if (response[0]) {
      selectedAreaId.value = response[0].id;
      fetchShipList(response[0].id);
    }
  }
};

// 获取船舶列表
const shipList = ref<ShipVO[]>([]);
const fetchShipList = async (areaId: string) => {
  const response = await getShipWithTypeListByAreaId(areaId);
  if (response) {
    shipList.value = orderBy(response, ["status.id"], ["desc"]);
  }
};

// 获取授权状态
const getAuthorizationStatus = (
  authorization: ShipAuthorization | undefined
) => {
  if (!authorization) return t("UIV.unauthorized");
  if (authorization.status == 0) return t("UIV.unauthorized");
  else if (authorization.status == 1) return t("UIV.authorized");
  else return t("UIV.authorizing");
};
const getAuthorizationStatusClass = (
  authorization: ShipAuthorization | undefined
) => {
  if (!authorization) return "text-red";
  if (authorization.status == 0) return "text-red";
  else if (authorization.status == 1) return "text-green";
  else return "text-yellow";
};

// 处理area点击事件
const selectedAreaId = ref<string>();
const handleAreaClick = (areaId: string) => {
  selectedAreaId.value = areaId;
  fetchShipList(areaId);
};
// 查看详情按钮点击
const handleCheckInfoClick = (shipId: string) => {
  router.push({
    name: "shipInfo",
    query: { shipId: shipId },
  });
};

// 创建区域
const createdAreaDialogVisible = ref<boolean>(false);
const createdAreaName = ref<string>("");
const btnCreatedAreaLoading = ref<boolean>(false);
const submitCreatedArea = async () => {
  if (createdAreaName.value.trim() === "") {
    ElMessage.error("区域名称不能为空！");
  }
  if (_.some(areaNameList.value, { name: createdAreaName.value })) {
    ElMessage.error("区域名称已存在！");
    return;
  }
  btnCreatedAreaLoading.value = true;
  const response = await createAreaApi(userId.value, createdAreaName.value);
  btnCreatedAreaLoading.value = false;
  console.log(response);
  if (response === true) {
    createdAreaName.value = "";
    ElMessage.success("创建成功！");
    createdAreaName.value = "";
    fetchAreaList();
    createdAreaDialogVisible.value = false;
  } else {
    ElMessage.error("创建失败！");
  }
};

onMounted(() => {
  fetchUserById();
  fetchAreaList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (user.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", null, [
          _createElementVNode("i", {
            class: "iconfont icon-arrow_a",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
          }),
          _createTextVNode(" " + _toDisplayString(user.value.name), 1)
        ]),
        _createVNode(_component_el_descriptions, {
          "label-width": "150px",
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, {
              label: _ctx.$t('UIV.company')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(user.value.company?.trim() || _ctx.$t("UIV.empty")), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _ctx.$t('UIV.person')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(user.value.person?.trim() || _ctx.$t("UIV.empty")), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _ctx.$t('UIV.phone')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(user.value.phone?.trim() || _ctx.$t("UIV.empty")), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _ctx.$t('UIV.email')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(user.value.email?.trim() || _ctx.$t("UIV.empty")), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _ctx.$t('UIV.address')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(user.value.address?.trim() || _ctx.$t("UIV.empty")), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _ctx.$t('UIV.description')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(user.value.description?.trim() || _ctx.$t("UIV.empty")), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        _createElementVNode("h1", _hoisted_2, [
          _cache[5] || (_cache[5] = _createTextVNode(" 船舶列表 ", -1)),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (createdAreaDialogVisible.value = true))
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" 创建区域 ", -1)
            ]))]),
            _: 1
          })
        ]),
        (areaNameList.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_el_scrollbar, { class: "area-selection-box" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(areaNameList.value, (area) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: area.id,
                      class: _normalizeClass(["area", { selected: selectedAreaId.value == area.id }]),
                      onClick: ($event: any) => (handleAreaClick(area.id))
                    }, _toDisplayString(area.name), 11, _hoisted_4))
                  }), 128))
                ]),
                _: 1
              }),
              (shipList.value.length > 0)
                ? (_openBlock(), _createBlock(_component_el_scrollbar, {
                    key: 0,
                    class: "ship-list"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shipList.value, (ship) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: ship.id,
                          class: "ship"
                        }, [
                          _createElementVNode("p", _hoisted_5, _toDisplayString(ship.ship.name), 1),
                          _createElementVNode("p", _hoisted_6, [
                            _createElementVNode("i", {
                              class: "iconfont icon-dot",
                              style: _normalizeStyle({ color: _unref(getStatusColor)(ship.status.id) })
                            }, null, 4),
                            _createTextVNode(" " + _toDisplayString(_unref(getName)(ship.status)), 1)
                          ]),
                          (ship.authorization != null && ship.authorization.status !== 0)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                style: _normalizeStyle([{"width":"150px","font-size":"10px"}, {
              marginLeft: ship.authorization.status != 0 ? 'auto' : '0',
            }])
                              }, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.$d(new Date(ship.authorization.startTime), "long")), 1),
                                _createElementVNode("p", null, _toDisplayString(_ctx.$d(new Date(ship.authorization.endTime), "long")), 1)
                              ], 4))
                            : _createCommentVNode("", true),
                          _createElementVNode("p", {
                            style: _normalizeStyle([{"width":"100px"}, {
              marginLeft:
                ship.authorization == null || ship.authorization.status == 0
                  ? 'auto'
                  : '0',
            }]),
                            class: _normalizeClass(["authorization-status-text", getAuthorizationStatusClass(ship.authorization)])
                          }, _toDisplayString(getAuthorizationStatus(ship.authorization)), 7),
                          _createElementVNode("p", _hoisted_7, [
                            _createVNode(_component_el_button, {
                              size: "small",
                              type: 
                ship.authorization == null || ship.authorization!.status == 0
                  ? 'info'
                  : 'success'
              ,
                              disabled: 
                ship.authorization == null || ship.authorization.status != 1
              ,
                              onClick: ($event: any) => (handleCheckInfoClick(ship.id))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("UIV.checkInfo")), 1)
                              ]),
                              _: 1
                            }, 8, ["type", "disabled", "onClick"])
                          ])
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t("ship.noShip")), 1))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t("UIV.empty")), 1)),
        _createVNode(_component_el_dialog, {
          modelValue: createdAreaDialogVisible.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((createdAreaDialogVisible).value = $event)),
          title: "创建区域",
          width: "400"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: createdAreaName.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((createdAreaName).value = $event)),
              placeholder: "输入区域名称"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              type: "primary",
              style: {"width":"100%","margin-top":"7px"},
              onClick: submitCreatedArea
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode(" 创建 ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]))
    : _createCommentVNode("", true)
}
}

})